import React, { useState, useEffect, useRef } from 'react';
import { Table, Button, Space, Input, Select, Popover, Spin } from 'antd';
import { HomeOutlined, SearchOutlined, RedoOutlined, DownloadOutlined } from '@ant-design/icons';
import Message from '../../component/message/message';
import moment from 'moment';//日期格式化导包
import Audit from '../../component/audit/audit';//审核彈框
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import { ContextHandler } from '../../public/js/contextHandler';
import context from '../../public/js/context';

import trans from './translation';
import './jobApplicationRecord.css';
import { useLocation } from 'react-router-dom';
const { Option } = Select;

const JobApplicationReport = (props) => {

    const messageRef = useRef();
    const [isAudit, setIsAudit] = useState(false);
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [searchModel, setSearchModel] = useState(useLocation().model ?? {});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [auditModel, setAuditModel] = useState({});
    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [checkboxState, setCheckboxState] = useState([]);
    const [downloadModel, setDownloadModel] = useState("");


    const tableColumns = {
        companyName: "company_name",
        jobId: "job_id",
        jobTitle: "job_title",
        jobApplId: "job_appl_id",
    }

    useEffect(() => {
        search(pageSize, 1, "N");
    }, []);

    const search = (pageSizeNew, currentPageNew, flag, isShowMsg) => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        messageShowHandler();  // 清除提示信息
        let model = {};
        if ("Y" === flag) {     // 翻页
            model = oldSearchModel;
        } else {
            model = searchModel;
        }
        model.page = currentPageNew;
        model.startRow = (currentPageNew - 1) * pageSizeNew;
        model.pageSize = pageSizeNew;
        model.progCodeList = Config.userInfo?.progCodeList
        model.cohortYear = Config.cohort?.cohortYear
        setDownloadModel(model)
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("jobApplication/searchReport", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data?.object?.list && isShowMsg) {
                    errFrameShow("info", trans.noneDate[Config.backLang]);
                }
                if ("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(model)));
                }
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(currentPageNew);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const searchChange = (key, value) => {
        messageShowHandler();
        setSearchModel(model => {
            return { ...model, ...{ [key]: value } };
        });
    }

    const reset = () => {
        messageShowHandler();
        clearSelect();
        setSearchModel({});
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
    }

    const auditCancel = () => {
        setIsAudit(false);
    }


    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }

    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }

    //清空列表选中
    const clearSelect = () => {
        setSelectedRowKeys([]);
        setCheckboxState([]);
    }

    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!searchModel.orderBy) {
            if (orderBy !== searchModel.orderBy) {
                searchModel.orderBy = orderBy;
                search(pageSize, 1, "N", true);
            }
        }
    }

    /*eslint-disable*/
    const columns = [
        {
            title: 'Job App ID',
            dataIndex: 'jobApplId',
            className: 'tableWidth5',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'jobApplId') },
        },
        {
            title: trans.programmeTitle[Config.backLang],
            dataIndex: 'progTitle',
            className: 'tableWidth8',
            ellipsis: true,
            render: (text) => <Popover content={text} title="" trigger="hover">
                <div className="jobPostContent">{text}</div>
            </Popover>
        },
        {
            title: trans.jobId[Config.backLang],
            dataIndex: 'jobId',
            className: 'tableWidth4',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'jobId') },
        },
        {
            title: trans.jobTitle[Config.backLang],
            dataIndex: 'jobTitle',
            className: 'tableWidth8',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'jobTitle') },
            ellipsis: true,
            render: (text) => <Popover content={text} title="" trigger="hover">
                <div className="jobPostContent">{text}</div>
            </Popover>
        },
        {
            title: trans.jobApplStatus[Config.backLang],
            dataIndex: 'jobApplStatus',
            className: 'tableWidth6',
            render: (text) => ContextHandler.getMapValue('jobApplStatusMap', text)
        },
        {
            title: trans.applyDate[Config.backLang],
            dataIndex: 'applyDate',
            className: 'tableWidth12',
            render: (text) => text ? moment(text).format(Config.dateFormat5) : ""
        },
        {
            title: 'Job Post Application Deadline',
            dataIndex: 'lastApplyDate',
            className: 'tableWidth10',
            render: (text) => text ? moment(text).format(Config.dateFormat5) : ""
        },
        {
            title: trans.studentID[Config.backLang],
            className: 'tableWidth6',
            dataIndex: 'studentUserCode',
        },
        {
            title: trans.studentName[Config.backLang],
            className: 'tableWidth9',
            render: (text, record) => <div>{record.firstName + " " + record.lastName}</div>
        },
        {
            title: 'Email',
            dataIndex: 'email',
            className: 'tableWidth3',
            render: text => text?.trim() ? 'Yes' : 'No',
        },        
        {
            title: 'Contact Phone',
            dataIndex: 'contactPhone',
            className: 'tableWidth6',
            render: text => text?.trim() ? 'Yes' : 'No',
        },        
        {
            title: 'WeChat',
            dataIndex: 'weChat',
            className: 'tableWidth4',
            render: text => text?.trim() ? 'Yes' : 'No',
        },        
        {
            title: 'Personal Web',
            dataIndex: 'personalWeb',
            className: 'tableWidth5',
            render: text => text?.trim() ? 'Yes' : 'No',
        },        
        {
            title: 'WhatsApp',
            dataIndex: 'whatsApp',
            className: 'tableWidth4',
            render: text => text?.trim() ? 'Yes' : 'No',
        },        
        {
            title: 'LinkedIn',
            dataIndex: 'linkedIn',
            className: 'tableWidth4',
            render: text => text?.trim() ? 'Yes' : 'No',
        },
        {
            title: 'Additional Files',
            dataIndex: 'fileCount',
            className: 'tableWidth6',
            render: text => text > 0 ? 'Yes' : 'No',
        },
        {
            title: 'Links',
            dataIndex: 'linkedIn',
            className: 'tableWidth3',
            render: (text, record) => record.portfolioLinkOne?.trim() || record.portfolioLinkTwo?.trim() || record.portfolioLinkThree?.trim() ? 'Yes' : 'No',
        },
    ];
    /*eslint-enable*/

    const downloadExcel = () => {
        messageShowHandler();//清空提示信息
        setIsLoad(true);
        setSpinInfo(trans.download[Config.backLang])
        const filename = "Job Application Report" + moment(new Date()).format(Config.dateFormat3) + Base.generateFourDigitRandomNumber() + ".xlsx"
        fetch(Config.apiDownloadServer + "jobApplicationReport/exportJobApplicationReport", {
            method: 'POST',
            body: JSON.stringify(downloadModel),
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.blob()).then(blob => {
            if (blob.type == "application/json") {
                var reader = new FileReader();
                reader.onload = e => {
                    var data = JSON.parse(e.target.result);
                    errFrameShow("error", data.msg);
                }
                reader.readAsText(blob);
            } else {
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {// for IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {// for Non-IE (chrome, firefox etc.)
                    var a = document.createElement('a');
                    document.body.appendChild(a);
                    a.style = 'display: none';
                    var url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = filename
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);
                }
            }
        }).catch(err => ({ err })).finally(() => {
            setIsLoad(false)
        });
    }

    return (
        <div id="container" className="template jobApplicationRecord">
            <div className='breadcrumb'>
                <HomeOutlined /> / Admin / <span className='breadcrumbTitle'>{Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : '')]}</span>
            </div>
            {/* 提示信息弹框 */}
            <Message ref={messageRef} />
            <div className='templateMain'>
                <Spin size="large" spinning={isLoad} tip={spinInfo}>
                    {/* 审核彈框 */}
                    <Audit visible={isAudit} auditModel={auditModel} close={auditCancel} />
                            <div className='sysSearchRow sysSearchBox' style={{paddingTop:' 12px'}}>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysTitle">{trans.studentName[Config.backLang]}</div>
                                        <div className="sysSerchInput">
                                            <Input type="text" value={searchModel.studentName || ''}
                                                placeholder={trans.studentName[Config.backLang]}
                                                onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                                onChange={(e) => searchChange('studentName', e.target.value)} />
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysTitle">{trans.jobTitle[Config.backLang]}</div>
                                        <div className="sysSerchInput">
                                            <Input type="text" value={searchModel.jobTitle || ''}
                                                placeholder={trans.jobTitle[Config.backLang]}
                                                onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                                onChange={(e) => searchChange('jobTitle', e.target.value)} />
                                        </div>
                                    </div>
                                    {/* <div className='sysCol'>
                                        <div className="sysTitle">{trans.industrialPartner[Config.backLang]}</div>
                                        <div className="sysSerchInput">
                                            <Input type="text" value={searchModel.companyName || ''}
                                                placeholder={trans.industrialPartner[Config.backLang]}
                                                onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                                onChange={(e) => searchChange('companyName', e.target.value)} />
                                        </div>
                                    </div> */}
                                    <div className='sysCol'>
                                        <div className="sysTitle">{trans.jobApplStatus[Config.backLang]}</div>
                                        <div className="sysSerchInput">
                                            <Select className='sysSelect'
                                                value={searchModel.jobApplStatus || ''}
                                                onChange={(value) => searchChange('jobApplStatus', value)}>
                                                <Option value=''></Option>
                                                {context.jobApplStatusMap.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                            </Select>
                                        </div>
                                    </div>
                                    <div className='sysSearchButton'>
                                        <Button className="sysBtn btnBlue" type="primary" onClick={() => search(pageSize, 1, "N", true)} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>{trans.search[Config.backLang]}</Button>
                                        <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>{trans.reset[Config.backLang]}</Button>
                                    </div>
                                </div>
                            </div>
                            <div className="sysLineEight"></div>
                            <Space size={[5, 5]} wrap className="sysButtonRelative">
                                {tables.length == 0 ? null :
                                    <>
                                        <Button className="sysBtn btnBlue" type="primary" onClick={downloadExcel} hidden={Config.funcInfo.canDownload === "N"} icon={<DownloadOutlined />}>Export</Button>
                                    </>
                                }
                            </Space>
                            <div className="sysTable" id="tableOne">
                                <Table
                                    scroll={{ x: 2500 }}
                                    rowKey="jobApplId" //Key值
                                    columns={columns} //列名
                                    dataSource={tables} //数据
                                    pagination={{  //分页
                                        showSizeChanger: true,                //是否显示可以设置几条一页的选项
                                        onChange: onChange,                  //上页下页或者跳页方法
                                        onShowSizeChange: onShowSizeChange,          //每页显示条数方法
                                        total: tablesCount,        //总共多少条数据
                                        current: current,       //当前页
                                        pageSize: pageSize,  //每页显示多少条数据
                                        defaultCurrent: 1,          //默认当前页为1
                                        size: "small"
                                    }}
                                    onChange={handleTableChange}
                                />
                            </div>
                </Spin>
            </div>
        </div>
    )

}
export default JobApplicationReport;